// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8916b217","238":"9850df6a","773":"b2b0f06f","787":"6e14a2d5"}[chunkId] + ".chunk.js";
};